export const getBoundarySecondaryLabels = (boundary: {
  state?: string;
  country?: string;
}): string[] => {
  return [boundary.state, boundary.country].filter(Boolean) as string[];
};

export const getBoundaryDisplayName = (boundary: {
  name: string;
  state?: string;
  country?: string;
}): string => {
  const secondaryLabels = getBoundarySecondaryLabels(boundary);
  return secondaryLabels.length > 0
    ? `${boundary.name}, ${secondaryLabels.join(", ")}`
    : boundary.name;
};
